import { atom } from 'jotai';

const highlightDimensionAtom = atom<Array<{ backendName: string; level: number }>>([]);
const isConfigLoadingAtom = atom(true);
const totalCombinationsAtom = atom(0);

export { highlightDimensionAtom, isConfigLoadingAtom, totalCombinationsAtom };
